export class CONSTANTS {
  public static ResourceKind = {
    ClassificatorId: '7bd08499-f173-4411-9de3-9e88163274e5',
    Machine: 'bb97582b-8555-4236-9b05-97ac703b92aa',
    Person: 'a042d5c5-d648-4e28-ac07-a235121b6bfd',
    Skill: 'd1b977b4-1620-4955-9d88-702079b54d5a',
    Area: '0fc446e4-b2e0-444a-b596-eaa809d67282',
    Workcenter: 'e9ed0a0e-5be2-4d53-9517-aeadd1e2654d',
    Team: '3f5a0d6c-b52f-43d0-b0f7-9904f33a0529',
    Device: '81054bb6-7053-42a3-937a-dbd975e2a7a1',
    Template: 'cac9cdda-1b4d-415c-a6d6-537009bf24c4'
  };

  public static PrintDocuments = {
    Id: '09069f9a-44d1-4f42-a0ba-f2b18c7fbeac'
  };

  public static PrintFormat = {
    Id: 'fe76d9e7-1fd8-434e-9fed-d27fa526e72e'
  };

  public static OperationStatus = {
    ClassificatorId: '6db31fb5-373a-4552-b74d-d7ef7e537fcc',
    Scheduled: '18781e27-701a-433e-9768-19739219baad',
    Started: '1870f271-b30d-446e-9a0e-fbbce8d4d009',
    Completed: 'd5f2490c-d460-4efa-91d4-5de1fd899b80',
    Unscheduled: 'db95f1a6-a06f-47b4-979c-3a7a002018c3',
    Released: '3f2e0e63-5674-4ba6-b1f9-4cca9dc22c6f',
    Frozen: 'cd2e1faa-504c-43d1-9f3e-d66fdb0e7f1d',
    Skipped: 'b48f4f00-bd1d-4bc0-aaea-8e9e837ea8ba',
    Paused: 'd16a651d-3182-4b65-9c88-28c3948ff6f6',
  };

  public static OperationType = {
    ClassificatorId: 'e80d5bd7-5488-4449-a4b6-683bf7b6b5b5',
    SplitOperationRoot: '5f8059e0-5d4b-4332-93e3-6bb3d4b43019',
    Operation: 'c3210d62-7947-420b-bb6b-a07592690231',
    OperationGroup: 'ceffd554-819c-4da8-bfb8-f14e72644330',
    SetupTask: '1e65060a-9211-4f62-8fe3-86946025b67c',
    ProductionTask: 'b41dd94c-db9c-4dc2-a89d-06a9e9e59a3f'
  };

  public static PropertyType = {
    ClassificatorId: 'ff5ee068-6a14-4d60-b41a-66975d6231a2',
    Choice: '87a7ce66-5960-4e1c-b1c2-50c717bf6b80',
    Numeric: 'a8217081-8cda-40a1-b6c0-de33462eaee3',
    Text: '54c727a8-3227-4c31-88b9-4bf0eef4ad8f',
    Html: 'e058a48a-a444-4f90-8240-99ac0cb2ee02',
    DateTime: '7798e9f7-37d5-4a9b-afed-f7eefe6f4247',
    Json: '9dd63d83-6b6e-45e2-b4eb-976698415de9',
    FileLink: '1ac26d74-e64d-433f-bd32-cc203cf1c9c6',
};

  public static PropertyGroup = {
    ClassificatorId: '99eb0551-8a99-404d-8d5f-4c54a8e352a3',
    Resource: '013ae6ea-82f0-43c2-96a2-3806065c27a7',
    System: '0c57d8ad-ee36-43ba-ba81-8792ce9fd70d',
    General: '8848e280-bb6b-4975-a68b-cb65e4a3680c',
    Checklist: '4dd95abc-dc49-4e81-9a35-1f88a95f5b97',
    Filters: 'a3e36b97-eb0a-484d-ae59-497732fb0214'
  };

  public static MappingOrigin = {
    ClassificatorId: '22035f3f-2dfa-4bad-bdee-6ab6564332f5',
    General: '822b131b-8bb2-4ef2-a288-0437127c1275',
    Mes: 'd9bb940a-b94d-4447-aed6-19243185508d',
    MesSetup: 'cfba181c-b34b-405f-aa27-7cad5c7cd4c6',
    MesProduction: 'eaee386b-83ff-49e0-bc55-ea704bc48759',

    get All() {
      return [...Object.keys(CONSTANTS.MappingOrigin).filter(value => value !== 'All' && value !== 'ClassificatorId').map(key => CONSTANTS.MappingOrigin[key])];
    }
  };

  public static Bottleneck = {
    ClassificatorId: 'b6703298-0dbe-4024-9c02-f8b94d5265ea',
    Normal: 'b9909df8-e7c5-4ba6-af01-daca7777da94'

  };
  public static ResourceType = {
    ClassificatorId: '7b2aec06-1d79-4d97-9e4d-60a9212ee400',
    MainResource: '6f1bd2ba-80dc-4292-ab19-0e10f697d527'
  };
  public static ResourceConnectionType = {
    ClassificatorId: '36011d8c-b2f0-4747-9299-e05352c44199',
    Area: 'd88ca0c4-e684-4e14-857b-1d8123868a92',
    Skill: '8fea627e-feb2-4751-be61-f10050603a65',
    Machine: 'b09abbae-6614-438c-81f2-c90c4590e5bb',
    Hierarchy: 'ec15505f-6760-48f3-9c76-c357f3085f1d'
  };
  public static AssignedResourceQuantityFlag = {
    ClassificatorId: '38cad70f-e7f8-45c7-b074-28ee306d7055'
  }
  public static ResourceQuantityConstraints = {
    ClassificatorId: '7a84a306-acda-4d47-9f63-edb446de86c6'
  }
  public static Mandatory = {
    ClassificatorId: '140f1716-a981-4c8f-90d5-8e2aa9173ba6',
    Optional: '84a41e26-2f64-425a-a1fe-7d04fec0ed58',
    Freezed: '2b72b0e8-8fb0-473c-b5b9-0b590dd6475f',
    Required: '7244ed75-723e-47f6-a3d9-1134a68c03a0',
    Hidden: 'd27e7d24-7767-43a8-8d8a-dcf644ca752d',
  };

  public static Boolean = {
    ClassificatorId: 'a12ebf95-c722-4f31-9c39-b8b3c436d967',
    True: '4afbd3b5-288d-4af6-9f1f-b272107baec6',
    False: 'b3871214-e676-4594-b61d-dab33d822fd6'
  };

  public static ObtainMethod = {
    ClassificatorId: '2728b160-98f3-4ff0-945e-f179b05cb89d',
    PreferToProduce: '037526c7-e6fe-4b6e-9ac1-2f5886dcd381'
  };

  public static ItemType = {
    ClassificatorId: 'eeec71f2-5711-4fc4-89e6-1e0ef74e5a51',
    RawMaterial: '49895189-efa8-40dc-9787-b9f797ec6e7f',
    IntermediateItem: 'aa7c8beb-a7ef-4ef5-ac18-e02a0116f4df',
    FinishedItem: 'fdb7f2bd-28a0-4f00-b502-8d9c1df4b623',
    PurchasedPart: '3fe589b5-8f14-495e-92a1-19a7c9c7a45b',
    Phantom: '29459dba-59e4-4b75-b11b-e79b8a313c96',
    ManufacturedPart: '337471c2-ef3d-4d5c-bd7b-9b48d11eb88a',
  };

  public static ItemStatus = {
    ClassificatorId: '37fe9e65-292b-4290-b481-42d9bb8dd744',
    Draft: 'ed00e28e-83df-4237-ab37-806bdced78ba',
    Final: 'fab3a08e-a906-480d-9380-340ea8046836',
    Closed: '8441422c-1e62-4a51-bf30-adb569895ac4'
  };
  public static ItemGroupType = {
    ClassificatorId: '616e4183-b610-4172-9cb2-cc0f1add55d8',
    RawMaterial: 'e1a106f0-cc15-47a1-923e-f96b9590c9f0',
    SpecialProcess: 'b87a68e5-577e-4926-bc78-5010ac4a0a4c',
    ManufacturedItem: '11d817e7-43b2-4bad-8b21-c7cad1f769e6',
    Component: 'e399c2b6-5c52-48e4-a2b4-fff05157adf8',
    IntermediateItem: 'f45ffaee-ec0d-4711-888f-48ea161cbb9f',
    Alternative: 'dbb9770c-bfff-4110-a971-ebf8313ba80c',
    Template: 'da7f0aa3-2da8-4ff3-aacf-0e395896351b'

  };
  static AutoReplenishFlag = {
    ClassificatorId: 'd83a3103-0b0f-4bd9-b16f-ef0a19ecf4e5'
  };
  static TimeConstraintMethod = {
    ClassificatorId: '05e35716-97fb-4ac7-ae8e-75b4585c0d1d',
    ES: '16db04ef-2b3c-4622-934b-77352ed8be0f'
  };
  static PhysicalDimension = {
    ClassificatorId: '79774710-7048-48f6-b1ee-e8c4024b8d86'
  };

  public static CostPriceComponentSurchargeType = {
    ClassificatorId: '070EC311-256B-4E9E-8736-FADD352F9AC6'.toLowerCase()
  }

  public static CostPriceComponentType = {
    ClassificatorId: '0911CEA4-096D-4E42-B155-4C3D7403F814'.toLowerCase(),
    Material: '16649b80-9b17-47e2-88e8-97f8d4a60164',
    Operation: 'dcb388d2-afab-4f9a-b51c-c417c813b36e'
  }

  public static ConfigureOrderHeaderStatus = {
    ClassificatorId: '8b1d1c6e-327a-4360-92aa-183cb471c039',
    Draft: '7cdc3f8a-94f3-4a5a-a575-cc9b9e00d6cb',
    Cancelled: 'c00d329d-5d75-442c-bb78-45b54057b76f'
  }

  public static ConfigureOrderLineStatus = {
    ClassificatorId: '8df6c65b-0ce0-4a00-9e55-6f66a8293d97',
    Draft: 'c9642fc7-9fb9-4b76-ad7e-e10903a7a3ee',
    Cancelled: 'f5f0401f-3d85-41b2-8a42-ea036a42180d'
  }

  public static OrderStatus = {
    ClassificatorId: '6a3e8fd1-a827-4588-b654-a3ed9b046745'.toLowerCase(),
    Closed: 'd50c1998-b2c3-4ff1-8493-22c6a27510f2'.toLowerCase(),
    Planned: 'a25d3059-5500-4b5e-ad26-3c326fc27f7c',
    Finished: '783e6d99-c709-45a6-9d24-961106c014ce',
    Started: 'adbe9f88-66cf-4c34-a170-8455a368be32',
    Paused: '4b920d23-c24b-4795-9308-f4be422f8460'
  }

  public static ConfiguratorStatus = {
    ClassificatorId: 'f9055206-5131-4efd-9bfd-b9680fa1ac39',
    Draft: '8cdce8db-bc46-4b38-b264-8cdbde6a9788',
    Canceled: 'c93304ea-9964-4bb9-8093-12464ba6ee85',
    Completed: 'c02d7784-b1ef-4b21-8b61-48b7912aa6e3'
  }

  public static ProductionOrderOrderType = {
    ClassificatorId: 'd5b32974-9a0f-4f8b-963e-b3241b47b5ba',
    SalesOrder: '2d40500f-0828-4e3e-bdd8-41c9a2284786',
    ManufacturingOrder: '745a600b-a8a8-4ce2-9c86-90178d549f20'
  }

  public static ProductionOrderOrderClass = {
    ClassificatorId: '006bc840-b943-4db8-abb3-355a34adbd82',
    RegisteredOrder: '064a0fc2-6458-47a8-bcce-4846260b000c',
    ReplenishmentOrder: '82388afe-f320-4ccf-8c1b-5016c4efcb54'
  }

  public static FinanceIntegrationEntryFinanceTransactionType = {
    ClassificatorId: '16dc544b-7176-45f1-b4d6-6de9234d3dd4',
    Receipt: '091912f8-facd-445e-836e-c99a3755bc3c'
  }

  public static SalesOrderHeaderType = {
    ClassificatorId: 'c5ba8cf8-68e2-4df6-bf54-923e3f36155d',
    Common: '5f6ad0e9-5d58-424f-9423-a687c6e0736f',
    Standard: '22cb7240-a034-4679-8971-96b2ccdc40bd',
    External: '372ed273-1800-42fd-b271-e8099f6e12ff'
  }

  public static SalesOrderHeaderStatus = {
    ClassificatorId: 'afd28ef7-9914-48d7-832b-104bf356f809',
    Open: 'e3dedea6-a1c9-4eb6-87c7-9794e37f2616',
    Confirming: '4a580f6b-4f39-4195-b239-d43ceb246423',
    Confirmed: '30024125-0e7f-4e25-972c-9edcae4bd1f9',
    Failed: 'db31a3d2-f864-4883-9364-dacc71c46e00'
  }

  public static SpecPriority = {
    ClassificatorId: '02338315-cdba-4aa3-9a2f-00628b35c3ee',
    Low: 'a63aff95-3a90-4e2d-84c1-237fdd676eb9',
    Medium: '92e31b60-442d-487b-99b9-060742b3fc24',
    High: 'c9fb9e6e-85e5-4619-be47-1904742909cc',
  }

  public static ExplodeServer = {
    ClassificatorId: '891967cc-feae-4b23-9649-b34f6eaf63a1',
    Default: '34a80ed2-a01c-4c5c-85d1-424d9e150642'
  }

  public static ResourceStatus = {
    ClassificatorId: 'be765261-e737-4e1d-92f4-48b8709edafb'
  };

  public static ItemGroupStatus = {
    ClassificatorId: 'adb87d1e-72ab-4f68-9386-64bd7ac36d84',
    Draft: 'f4e69d60-0ecc-466f-8ab7-6a001401865e',
    Final: 'a514da76-755c-4e2b-971e-82fbdc0c4899'
  };

  public static Placement = {
    ClassificatorId: '5af5990f-8850-4c24-8868-de8fda3fbcba',
    First: '4492853a-cd69-4826-b138-174fb8a4e4e4',
    Middle: '52a7904c-a760-41b1-b217-59bef33daad1',
    Last: '74cdbc3a-76c6-4cef-9913-2aaac7a0fad5'
  }

  public static ClassificatorType = {
    ClassificatorId: '0d416ff3-f01c-4e8c-82a0-f42a0eab236c',
    Default: '009a46fa-9501-41c1-9d76-81923178e76d',
    Image: '858078e9-9eda-4898-99af-65d877e51836',
    Json: 'dc47cc4f-4bce-44c8-b19c-6872523667cb'
  }

  public static Owner = {
    ClassificatorId: 'd34dcc8d-4a22-4ddc-9262-ab3a71a66e46',
    Ime: 'd54efe1a-fd09-45b1-ab2d-8a8a6e3e8b13',
    External: '59edce03-4449-493c-923b-1b7c53e0222e',
    Mes: '1b42a45a-2c44-4773-b629-f3cc3a07b3e8',
    Asprova: '3fed7422-4599-4b8f-851c-911b63e78bf6'
  }

  public static ItemInItemGroupType = {
    ClassificatorId: '67929d1f-4772-4193-ad4c-591ed813f909',
    Main: '55b080d7-b491-47b7-96ee-a6ecb05f0c86',
    Mes: '2cb46251-ffe7-4ec9-b6cb-838edb02afe5'
  }

  public static OrderMethod = {
    PlannedOrder: '099234e7-6d86-4e0c-a66a-2969b0e64f50'
  }

  public static OutboundMethod = {
    NotRequired: '92ae35e6-4770-4693-9a7d-5ba9f6882c86'
  }

  public static LotControl = {
    ByLot: 'eeb1e2f1-02c1-478e-a97d-bb4a771db400'
  }
}
